'use client';

import { useShopifyScript } from '@dealerportal/catalog-ui';
import type { ProductInformation } from '@dealerportal/common';
import { useTranslations } from '@dealerportal/i18n/client';
import { useClientContext } from '@dealerportal/react-helpers';
import { BetterButton } from '@dealerportal/ui-components/BetterButton';
import classNames from 'classnames';
import { type MouseEventHandler, useCallback, useEffect } from 'react';
import { useState } from 'react';

export const Samples = ({
  productInfo,
  samplePrice,
  replaceClass = {},
  visible = true,
  isLoading = false,
  onClick = () => {},
  labelClass = '',
}: {
  productInfo: Partial<ProductInformation>;
  samplePrice?: number;
  replaceClass?: object;
  visible?: boolean;
  labelClass?: string;
  isLoading?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}) => {
  const ctx = useClientContext();
  const t = useTranslations('products');
  const [isScriptReady, setIsScriptReady] = useState(true);
  const checkScriptReady = useCallback(
    (interval: string | number | NodeJS.Timeout | undefined) => {
      if ((window as any)['ShopifyBuy'] !== undefined) {
        setIsScriptReady(true);
        clearInterval(interval);
      }
    },
    []
  );

  useEffect(() => {
    const intId = setInterval(checkScriptReady, 1000);
    checkScriptReady(intId);
    return () => {
      clearInterval(intId);
    };
  }, [checkScriptReady]);

  const { loadScript, isLoaded } = useShopifyScript({ autoRegister: true });

  useEffect(() => {
    if (!isLoaded) loadScript();
  }, [isLoaded, loadScript]);

  return (
    <>
      <BetterButton
        label={`${samplePrice ? `($${samplePrice}) ` : ''}${t('orderSample')}`}
        labelClassName={classNames('ui-text-sm', labelClass)}
        btnStyle="primary"
        attributes={{
          id: 'adhawk-shopify-camilyo-marketplace-order-sample',
          onClick: onClick,
          'data-product-handle': productInfo.UPID,
          'data-universal-retailer-id': ctx.universalRetailerId,
          disabled: !isScriptReady,
        }}
        className={classNames({
          '!ui-hidden': !visible,
        })}
        replaceClass={replaceClass}
        isLoading={isLoading || !isScriptReady}
      />
    </>
  );
};
